import { OAuthProvider } from './model/o-auth-provider';

export class StartOAuth {
  static readonly type = '[OAuth] Start oAuth';
  constructor(public provider: OAuthProvider) {}
}

export class VerifyOAuth {
  static readonly type = '[OAuth] Check if user signed in at oAuth provider';
  constructor(public timeoutInMilliseconds: number) {}
}

export class CompleteOAuth {
  static readonly type = '[OAuth] Complete oAuth';
}

export class CancelOAuth {
  static readonly type = '[OAuth] Cancel oAuth';
}
